<template>
  <base-echart
    :options="option"
    @legendselectchanged="handleLegendSelectChange"
  />
</template>

<script>
import { getMasterDataText } from '../../helpers'

const colors = [
  '#ff7675', // red
  '#fdcb6e', // blue
  '#0984e3', // green
]

export default {
  props: [
    'items',
    'type',
    'selectedKey',
  ],

  computed: {
    mapItems () {
      return this.items.reduce((acc, cur) => {
        cur.items.map((item) => item.fieldName).forEach((fieldName) => {
          if (!acc.includes(fieldName)) {
            acc.push(fieldName)
          }
        })
        return acc
      }, [])
    },
    barChartLineChartOption () {
      const series = this.mapItems.map((fieldName, index) => {
        return {
          data: this.items.map((item) => {
            const result = item.items.find((itemFields) => (
              itemFields.fieldName === fieldName
            ))
            return result ? result[this.selectedKey] : null
          }),
          type: this.type,
          stack: 'a',
          name: getMasterDataText(fieldName, this.$t),
          label: {
            show: true,
            formatter: (params) => {
              return [null, '-', 0].includes(params.value)
                ? params.seriesName
                : `${params.seriesName} - ${this.getNumber(params.value)}`
            },
          },
          color: colors[index],
        }
      })
      return {
        legend: {
          selectedMode: true,
        },
        xAxis: {
          type: 'category',
          data: this.items.map((item) => item.date),
        },
        yAxis: {
          type: 'value',
        },
        series: series,
      }
    },
    pieChartOption () {
      return {
        color: colors,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '70%',
            label: {
              show: true,
              formatter (param) {
                return param.name + ' (' + param.percent + '%)'
              },
            },
            data: this.mapItems.map((fieldName) => {
              return {
                value: this.items.reduce((acc, cur) => {
                  const total = cur.items.reduce((_acc, _cur) => {
                    if (_cur.fieldName === fieldName) {
                      _acc += _cur[this.selectedKey]
                    }
                    return _acc
                  }, 0)
                  return acc + total
                }, 0),
                name: getMasterDataText(fieldName, this.$t),
              }
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
    option () {
      if (this.type === 'bar' || this.type === 'line') {
        return this.barChartLineChartOption
      }
      return this.pieChartOption
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('update:selected-labels', params.selected)
    },
  },
}
</script>

<style scoped>
.chart-container /deep/ .echarts {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/ReportPurchaseDataChart.vue